import { createTheme } from "@mui/material/styles";

/**
 * Konnect xD Platform Theme
 * Base theme configuration for all applications
 */
export const kxdTheme = createTheme({
  palette: {
    primary: {
      main: "#002366", // Konnect dark blue
      light: "#1a3f7d",
      dark: "#001847",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#28154A", // Deep purple
      light: "#4a2c6b",
      dark: "#1a0e32",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: {
      fontSize: "2.5rem",
      fontWeight: 600,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 600,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 600,
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
});

export default kxdTheme;
